import * as React from 'react'
import styled from 'styled-components'
import SolidBorderWhiteBgButton from '@/components/atoms/buttons/solidBorderWhiteBg'
import LeftAlignedLogo from '@/components/atoms/logo/leftAlignedLogo'
import chevron_black_to_right from '@/public/assets/icons/chevron_black_to_right.svg'
import chevron_blue_to_right from '@/public/assets/icons/chevron_blue_to_right.svg'
import { useRouter } from 'next/router'
import Link from 'next/link'

interface IStyle {
    $isBlue: boolean
}

const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-top: 20px;
`

const TopButtonsWrap = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 30%;
`
const BackToGarage = styled.div<IStyle>`
    display: flex;
    align-items: center;
    font-size: 20px;
    color: ${(props) => (props.$isBlue ? '#00a9af' : '#242424')};
    letter-spacing: 2px;
    cursor: pointer;
`
const BackIcon = styled.div<IStyle>`
    background-image: ${(props) =>
        props.$isBlue
            ? `url(${chevron_blue_to_right.src})`
            : `url(${chevron_black_to_right.src})`};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    height: 20px;
    width: 25px;
    transform: rotate(180deg);
`

interface Props {}

const TopOfPageWithLogo: React.FunctionComponent<Props> = (props) => {
    const router = useRouter()
    let car_id = router.query.car_id
    let link_id = router.query.link_id

    const [isBlue, setIsBlue] = React.useState(false)

    return (
        <Wrapper>
            {car_id ? (
                <Link href={`/garage/${link_id}`}>
                    <a>
                        <BackToGarage
                            $isBlue={isBlue}
                            onMouseEnter={() => setIsBlue(true)}
                            onMouseLeave={() => setIsBlue(false)}
                        >
                            <BackIcon
                                $isBlue={isBlue}
                                onMouseEnter={() => setIsBlue(true)}
                                onMouseLeave={() => setIsBlue(false)}
                            />
                            <div style={{ paddingRight: '10px' }} />
                            GARAGE
                        </BackToGarage>
                    </a>
                </Link>
            ) : (
                <LeftAlignedLogo dataAttId="platform_logo" />
            )}
            <TopButtonsWrap>
                <a
                    href="https://app.custodian.club/register"
                    target="_blank"
                    rel="noreferrer"
                    data-attr="register_button"
                >
                    <SolidBorderWhiteBgButton
                        text={'Register'}
                        onClick={() => {}}
                        height="38px"
                    />
                </a>
                <div style={{ paddingRight: '20px' }} />
                <a
                    href="https://app.custodian.club/signin"
                    target="_blank"
                    rel="noreferrer"
                    data-attr="login_button"
                >
                    <SolidBorderWhiteBgButton
                        text={'Log in'}
                        onClick={() => {}}
                        height="38px"
                    />
                </a>
            </TopButtonsWrap>
        </Wrapper>
    )
}

export default TopOfPageWithLogo
